import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSession } from '../../state/session.tsx';
import { companyHasPlanFeature } from '../../components/plan-gate.tsx';
import { LoadingBlock } from '../../components/ui.tsx';
import TeamPaySection from '../../components/settings/team-pay-section.tsx';
import MarginFloorSection from '../../components/settings/margin-floor-section.tsx';
import { SettingsLeaf } from './settings-leaf.tsx';

/**
 * /settings/team-pay: pay and job profit (0035) on a page of its own. Same
 * gate as its card on /settings — the owner edits, managers read, crew never —
 * and kept apart from the roster, which is gated on `users:manage` instead.
 */
export default function TeamPayPage() {
  const { t } = useTranslation();
  const { company, can } = useSession();

  if (!company) return <LoadingBlock label={t('settings.loadingSettings')} />;
  if (!can('reports:read') || !companyHasPlanFeature(company, 'job_profit')) return <Navigate to="/settings" replace />;

  return (
    <SettingsLeaf title={t('settings.nav.sections.teamPay')} anchorId="settings-teamPay">
      <TeamPaySection />
      <MarginFloorSection />
    </SettingsLeaf>
  );
}
